export function emptyMiniProfile() {
  return { about_me: "", favourite_songs: "", relationship_status: "" };
}

export function miniProfileFromApi(mp) {
  if (!mp || typeof mp !== "object") return emptyMiniProfile();
  return {
    about_me: mp.about_me || "",
    favourite_songs: mp.favourite_songs || mp.favourite_dance || "",
    relationship_status: mp.relationship_status || "",
  };
}

export function miniProfileHasContent(mp) {
  if (!mp) return false;
  return Boolean(
    mp.about_me?.trim() || mp.favourite_songs?.trim() || mp.relationship_status?.trim()
  );
}

export function miniProfilePayload(mp) {
  if (!miniProfileHasContent(mp)) return null;
  return {
    about_me: mp.about_me?.trim() || null,
    favourite_songs: mp.favourite_songs?.trim() || null,
    relationship_status: mp.relationship_status?.trim() || null,
  };
}
